import { get, includes, some } from 'lodash';
import React, { useMemo } from 'react';
import CommunicationStatusModel from '../../../../model/CommunicationStatus';
import { EMAIL, NOTIFICATION } from '../../../../model/CommunicationType';
import itemIdValue from '../../../itemIdValue';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
const CommunicationStatus = ({ filter, value, ...rest }) => {
    const t = useT();
    const { options } = useEnumerableModel(CommunicationStatusModel);
    const hasNoCommunicationTypes = useMemo(() => !!(filter === null || filter === void 0 ? void 0 : filter.hasOwnProperty('communicationType')) &&
        !some(get(filter, 'communicationType'), type => includes([NOTIFICATION.value, EMAIL.value], type)), [filter]);
    const values = useMemo(() => (hasNoCommunicationTypes ? [] : value), [
        value,
        hasNoCommunicationTypes,
    ]);
    return (<MultiselectFilter {...rest} disabled={hasNoCommunicationTypes} filter={filter} itemId={itemIdValue} options={options} title={t('Communication Status')} value={values}/>);
};
export default CommunicationStatus;
